// layouts/UserLayout.js

import React from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "../components/users/Header";

const UserLayout = () => {
  const location = useLocation();

  const hideLayout =
    location.pathname === "/" ||
    location.pathname === "/login" ||
    location.pathname === "/seejob" ||
    location.pathname.startsWith("/career");

  return (
    <div className="min-h-screen">
      {!hideLayout && <Header />}

      <Outlet />
    </div>
  );
};

export default UserLayout;